<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { ComboboxItemEmits, ComboboxItemProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { ComboboxItem, useForwardPropsEmits } from 'reka-ui'
import { cn } from '@ds/lib/utils'

/*
 * Row metrics from DSSelectItem, minus the indicator gutter: a combobox commits
 * on pick and closes, so there is nothing to tick. `data-highlighted` is the
 * keyboard cursor and gets the accent, as in the select.
 */
const props = defineProps<ComboboxItemProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<ComboboxItemEmits>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <ComboboxItem
    v-bind="forwarded"
    :class="cn(
      'relative flex w-full cursor-pointer select-none items-center justify-between gap-3',
      'px-2.5 py-2 font-medium text-base outline-none',
      'data-highlighted:bg-accent data-highlighted:text-accent-foreground',
      'data-disabled:pointer-events-none data-disabled:opacity-50',
      props.class,
    )"
  >
    <slot />
  </ComboboxItem>
</template>
